import * as React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../../../action-creators";
import * as ScenariiService from "../../../service/sfp/scenarii-service";
import * as Common from "./common";
import ScenarioDetailComponent, { Data } from "./detail-component";
import TableDefinition, { TabId, Row, DicoChapter } from "./table-definition";
import Operations from "../common/operations";
import { ColorsHelper } from "../../../util/colors";
import * as LoanDomain from "../../../domain/sfp/loan-domain";
import * as UserDomain from "../../../domain/sfp/user-domain";
import * as Model from "../../../model";
import { ReducerState, MappedActionsProps } from "../../../reducer";
import * as moment from "moment";
import * as _ from "lodash";

// eslint-disable-next-line
// import createExportWorker from "workerize-loader!./export.worker" // do not remove this line!
// import * as ExportWorker from "./export.worker"
// const exportWorker: any = createExportWorker<typeof ExportWorker>()

function isSynthesis(currentTab: string) {
    return "synthesis" === currentTab;
}

class ScenarioDetailContainer extends React.Component<any, any> {
    revenues: any[];
    spending: any[];
    synthesis: any[];
    revenuesTableDef: any[];
    spendingTableDef: any[];
    synthesisTableDef: any[];
    data: any;
    tableDef: any;
    consulted: any;
    chartData: any;
    chartDataRevenues: any;
    chartDataSpending: any;
    chartDataRevenuesBar: any;
    chartDataSpendingBar: any;
    private currentYear = new Date().getFullYear();
    private tableDefs = {
        revenues: TableDefinition,
        spending: TableDefinition,
        synthesis: TableDefinition,
    };
    // Caches
    private _cachedOperations: Operations | null = null;
    private _cachedOperationsKey: string | null = null;
    private _cachedLoans: Model.PpiYearLoan[] | null = null;
    private _cachedLoansKey: string | null = null;
    private _interestByYearCache: Map<number, number> | null = null;
    private _obsMap: Map<string, any> | null = null;

    constructor(props: any) {
        super(props);

        this.revenues = [];
        this.spending = [];
        this.synthesis = [];
        this.revenuesTableDef = [];
        this.spendingTableDef = [];
        this.synthesisTableDef = [];
        this.data = null;
        this.chartData = null;
        this.chartDataRevenues = null;
        this.chartDataSpending = null;
        this.chartDataRevenuesBar = null;
        this.chartDataSpendingBar = null;
        this.state = {
            currentTab: "revenues",
            edit: false,
            graphic: false,
            loading: false,
            priorities: [],
            shownChapters: {
                revenues: [],
                spending: [],
            },
            submitting: false,
            years: this.createYears(props),
            isRendered: false,
            hideRows: false
        };
    }

    async componentDidMount() {
        this.generateData();        
    }

    generateData = () => {
        this.setState({ loading: !this.state.loading }, async () => {
            this.consulted =
                UserDomain.getProfile(this.props.currentUser) ===
                UserDomain.Profile.LocalAuthorityConsultant;
            this.tableDef = this.getTableDefinition();

            const rows: Row[] = _.get(this, "tableDef.rows", []);
            if (_.isEmpty(rows)) {
                this.setState({ loading: !this.state.loading });
            } else {
                this.data = await this.buildData(this.tableDef, "");

                // this.chartData = this.buildChartData(this.tableDef, this.data)
                // this.chartDataRevenues = this.buildChartDataRevenuesSpending(this.tableDef, this.data, true)
                // this.chartDataSpending = this.buildChartDataRevenuesSpending(this.tableDef, this.data, false)
                // this.chartDataSpendingBar = this.buildChartDataBar(this.tableDef, this.data, false)
                // this.chartDataRevenuesBar = this.buildChartDataBar(this.tableDef, this.data, true)

                this.setState({ loading: !this.state.loading });
            }
        });
    };

    componentDidUpdate(prevProps: Readonly<Props>, prevState: State) {
        if (prevProps.scenario !== this.props.scenario) {
            this.invalidateCaches();
            this.setState({ years: this.createYears(this.props) });
            this.generateData();
            return;
        }

        if (this.state.currentTab !== prevState.currentTab) {
            this.generateData();
            return;
        }
    }

    handleTabChange = (tab) => {
        this.setState({ currentTab: tab });
    };

    handleCloseGraphic = () => {
        this.setState({ graphic: false });
    };

    handleShowGraphic = () => {
        // only start to build chart data when click on graphic icon
        if (false === this.state.graphic) {
            setTimeout(() => {
                if (!_.isEmpty(this.data)) {
                    this.chartData = this.buildChartData(this.tableDef, this.data);
                    this.chartDataRevenues = this.buildChartDataRevenuesSpending(
                        this.tableDef,
                        this.data,
                        true
                    );
                    this.chartDataSpending = this.buildChartDataRevenuesSpending(
                        this.tableDef,
                        this.data,
                        false
                    );
                    this.chartDataSpendingBar = this.buildChartDataBar(
                        this.tableDef,
                        this.data,
                        false
                    );
                    this.chartDataRevenuesBar = this.buildChartDataBar(
                        this.tableDef,
                        this.data,
                        true
                    );
                }
                this.setState({ graphic: true });
            }, 200);
        } else {
            this.setState({ graphic: !this.state.graphic });
        }
    };

    onPrioritiesChange = (p) => {
        this.handlePrioritiesChange(p);
    };

    onHideRows = () => {
        let hideRows = !this.state.hideRows
        this.setState({ hideRows });
    }

    render() {
        if (
            _.isEmpty(this.tableDef) ||
            _.isEmpty(this.tableDef.rows) ||
            _.isEmpty(this.data)
        ) {
            return null;
        }

        return (
            <ScenarioDetailComponent
                pageTitle={this.props.title}
                consulted={this.consulted}
                scenario={this.props.scenario}
                tableDefinition={this.tableDef}
                headers={this.buildHeaders()}
                data={this.data}
                revenues={this.revenues}
                spending={this.spending}
                synthesis={this.synthesis}
                revenuesTableDef={this.revenuesTableDef}
                spendingTableDef={this.spendingTableDef}
                synthesisTableDef={this.synthesisTableDef}
                selectedPriorities={this.props.selectedPriorities}
                chartData={this.state.graphic ? this.chartData : null}
                chartDataSpending={this.chartDataSpending}
                chartDataRevenues={this.chartDataRevenues}
                chartDataSpendingBar={this.chartDataSpendingBar}
                chartDataRevenuesBar={this.chartDataRevenuesBar}
                currentTab={this.state.currentTab}
                hideRows={this.state.hideRows}
                Excel={() => this.calculateExcelfile()}
                onTabChange={this.handleTabChange}
                onBack={this.props.onBack}
                onChange={(t: Common.ChangeType, d: Common.ChangeData) =>
                    this.handleChange(t, d)
                }
                onCloseGraph={this.handleCloseGraphic}
                onPrioritiesChange={this.onPrioritiesChange}
                onHideRows={this.onHideRows}
                onShowGraphic={this.handleShowGraphic}
                onToggleChapter={this.handleToggleChapter.bind(this)}
                setSelectedPriorities={this.props.actions.setSelectedPriorities}
                loading={this.state.loading}
            />
        );
    }

    private buildHeaders(): number[] {
        return this.state.years.map((year) => year);
    }

    private calculateExcelfile() {
        ["revenues", "spending", "synthesis"].map((exportType) => {
            let tableDef = null;
            let table: any = null;
            let shownChapters;
            let shown = {
                revenues: [],
                spending: [],
            };

            switch (exportType) {
                case "revenues":
                    tableDef = this.getTableDefinitionExcel(exportType);
                    tableDef.rows.forEach((row) => {
                        let chapter = row.chapter;
                        const index = shown[exportType].indexOf(chapter && chapter.id);
                        shown[exportType].push(chapter && chapter.id);
                        shownChapters = shown;
                    });
                    table = this.getTableDefinitionExcelTable(exportType, shownChapters);
                    this.revenues = this.buildDataExcel(table, exportType, shownChapters);
                    this.revenuesTableDef = table;
                    break;

                case "spending":
                    tableDef = this.getTableDefinitionExcel(exportType);
                    tableDef.rows.forEach((row) => {
                        let chapter = row.chapter;
                        shown[exportType].push(chapter && chapter.id);
                        shownChapters = shown;
                    });
                    table = this.getTableDefinitionExcelTable(exportType, shownChapters);
                    this.spending = this.buildDataExcel(table, exportType, shownChapters);
                    this.spendingTableDef = table;
                    break;

                case "synthesis":
                    tableDef = this.getTableDefinitionExcel(exportType);
                    this.synthesis = this.buildDataExcel(tableDef, exportType, "");
                    this.synthesisTableDef = tableDef;
                    break;

                default:
                    break;
            }
        });

        this.setState({ isRendered: !this.state.isRendered });
    }

    private buildDataExcel(
        tableDef: ReturnType<typeof TableDefinition>,
        cur: string,
        shownChapters: any
    ): Data {
        const currentYear = this.props.scenario.year,
            loans = this.buildLoans(),
            operations = this.getOperations();

        let data: Data = [],
            previousScenario: Model.Scenario = null,
            rows = tableDef.rows,
            totalRow: any[] = ["Total"];

        if (this.props.scenario.year == this.currentYear + 1) {
            const previousScenarii = this.props.scenarii.find(
                (s) => s.year == this.props.scenario.year - 1
            );

            if (previousScenarii) {
                previousScenario = previousScenarii.scenarii.find((s) => s.validated);
            }
        }

        if (!isSynthesis(cur)) {
            rows = rows.filter((r, index) => index < tableDef.rows.length - 1);
        }

        for (const r of rows) {
            let row: any[] = [];

            if (!r.account || shownChapters[cur].indexOf(r.chapter.id) !== -1) {
                row.push(r.title);

                this.state.years.forEach((year, yearIndex) => {
                    const totalInterestByYear = this.getInterestByYear(year);
                    let value: Value = 0;
                    if (
                        year < currentYear &&
                        (year !== currentYear - 1 || !previousScenario)
                    ) {
                        value = this.calculateRetrospectiveValue(
                            r,
                            totalRow,
                            year,
                            yearIndex,
                            loans,
                            previousScenario
                        );
                    } else {
                        value = this.calculateProspectiveValue(
                            r,
                            operations,
                            year,
                            previousScenario,
                            totalInterestByYear,
                            currentYear,
                            totalRow,
                            yearIndex,
                            loans
                        );
                    }

                    row.push(typeof value === "number" ? Math.round(value) || "" : value);
                });
            }

            data.push(row);
        }

        if (!isSynthesis(cur)) {
            data.push(totalRow);
        }

        return data;
    }

    private buildData(
        tableDef: ReturnType<typeof TableDefinition>,
        cur: string
    ): Data {
        const currentYear = this.props.scenario.year,
            loans = this.buildLoans();
        const operations = this.getOperations();

        let data: Data = [],
            previousScenario: Model.Scenario = null,
            rows = tableDef.rows,
            totalRow: any[] = ["Total"];

        if (this.props.scenario.year == this.currentYear + 1) {
            const previousScenarii = this.props.scenarii.find(
                (s) => s.year == this.props.scenario.year - 1
            );

            if (previousScenarii) {
                previousScenario = previousScenarii.scenarii.find((s) => s.validated);
            }
        }

        if (!isSynthesis(this.state.currentTab)) {
            rows = rows.filter((r, index) => index < tableDef.rows.length - 1);
        }

        for (const r of rows) {
            let row: any[] = [];

            if (
                !r.account ||
                this.state.shownChapters[this.state.currentTab].indexOf(
                    r.chapter.id
                ) !== -1
            ) {
                row.push(r.title);

                this.state.years.forEach((year, yearIndex) => {
                    const totalInterestByYear = this.getInterestByYear(year);
                    let value: Value = 0;
                    if (
                        year < currentYear &&
                        (year !== currentYear - 1 || !previousScenario)
                    ) {
                        value = this.calculateRetrospectiveValue(
                            r,
                            totalRow,
                            year,
                            yearIndex,
                            loans,
                            previousScenario
                        );
                    } else {
                        value = this.calculateProspectiveValue(
                            r,
                            operations,
                            year,
                            previousScenario,
                            totalInterestByYear,
                            currentYear,
                            totalRow,
                            yearIndex,
                            loans
                        );
                    }

                    row.push(typeof value === "number" ? Math.round(value) || "" : value);
                });
            }
            data.push(row);
        }

        if (!isSynthesis(this.state.currentTab)) {
            data.push(totalRow);
        }

        return data;
    }

    private calculateProspectiveValue(
        r: Row,
        operations: Operations,
        year: number,
        previousScenario: Model.Scenario,
        totalInterestByYear: number,
        currentYear: number,
        totalRow: any[],
        yearIndex: number,
        loans: Model.PpiYearLoan[]
    ): Value {
        const scenarioYear = this.props.scenario.years.find((y: any) => y.year == year);

        if (r.account) {
            const induceds = operations.findInduceds(
                year,
                r.account.id,
                this.state.priorities
            );
            const value = operations.findValue(
                year,
                r.account.id,
                r.chapter.id,
                r.chapter.receipts,
                previousScenario,
                this.state.priorities
            );

            const yearAccount =
                scenarioYear &&
                scenarioYear.accounts.find(
                    (a) =>
                        a.account_id == r.account.id && a.receipts == r.chapter.receipts
                );

            const accountValue: Common.Value = {
                induceds,
                value,
                yearAccount: yearAccount || null,
                // id
            };

            if ("66111" === r.account.number){
                accountValue.value = this.calculateChapter66(scenarioYear, r.chapter.receipts, r.chapter.id, totalInterestByYear);;
                // En dette simplifiée, la valeur des intérêts emprunts réels provient
                // de la table de dette simplifiée : on ne lui ajoute pas les charges
                // induites pour rester cohérent avec l'écran de dette simplifiée.
                if (this.props.currentLocalAuthority.isDebtSimplified) {
                    accountValue.induceds = [];
                }
            }

            if (!previousScenario || year != currentYear - 1) return accountValue;

            return accountValue.value;
        } else if (r.chapter) {
            let value = r.chapter.accounts.reduce((result, account) => {
                if ("66111" === account.number) return result;
                const operationsValue = operations.findValue(
                    year,
                    account.id,
                    r.chapter.id,
                    r.chapter.receipts,
                    previousScenario,
                    this.state.priorities
                );

                return result + operationsValue;
            }, 0);

            if ("66" === r.chapter.number){
                value += this.calculateChapter66(scenarioYear, r.chapter.receipts, r.chapter.id, totalInterestByYear);
            }
            if (totalRow.length == yearIndex + 1) totalRow.push(0);

            totalRow[yearIndex + 1] += value;
            
            return value;
        } else if (r.func) {
            return r.func(
                "prospective",
                year,
                this.props.currentLocalAuthority,
                this.getOperations(),
                this.props.scenario,
                loans,
                previousScenario,
                this.props.loans
            );
        }
        return 0;
    }

    private calculateChapter66(scenarioYear: any, receipts: boolean, chapterId: number, totalInterestByYear: any){
        if (this.props.currentLocalAuthority.isDebtSimplified) {
            var amount = null;
            // On cible le compte 66111 (saisi depuis la dette simplifiée) et non
            // n'importe quel compte du chapitre 66 ayant une valeur annuelle.
            const laca66111 = this.props.currentLocalAuthority.accounts.find((o: any) => o.account.number === "66111");
            if (laca66111 && scenarioYear && scenarioYear.accounts && scenarioYear.accounts.length > 0) {
                const account = scenarioYear.accounts.find((o:any) => o.receipts === receipts && o.chapter_id == chapterId && o.account_id == laca66111.account.id);
                if (account) {
                    amount = account.amount;
                }
            }
            return amount != null ? amount : totalInterestByYear;
        } else {
            return totalInterestByYear;
        }
    }

    private calculateRetrospectiveValue(
        r: Row,
        totalRow: any[],
        year: number,
        yearIndex: number,
        loans: Model.PpiYearLoan[],
        previous_scenario: Model.Scenario
    ): number {
        const obsMap = this.getObsMap();

        if (r.account) {
            const obs = obsMap.get(`${year}-${r.account.id}`);

            return obs ? obs.amount : 0;
        } else if (r.chapter) {
            const value = r.chapter.accounts.reduce((result, account) => {
                const obs = obsMap.get(`${year}-${account.id}`);

                return obs ? result + obs.amount : result;
            }, 0);

            if (totalRow.length === yearIndex + 1) totalRow.push(0);

            totalRow[yearIndex + 1] += value;

            return value;
        } else if (r.func) {
            return r.func(
                "retrospective",
                year,
                this.props.currentLocalAuthority,
                this.getOperations(),
                this.props.scenario,
                loans,
                previous_scenario,
                this.props.loans
            );
        }

        return 0;
    }

    private buildChartData(
        tableDef: ReturnType<typeof TableDefinition>,
        baseData: Data
    ): Chart.ChartData {
        if (!isSynthesis(this.state.currentTab)) return null;

        const colors = ColorsHelper.getEquidistantPastelColors(5, 30);

        return {
            labels: this.state.years.map((year) => year.toString()),
            datasets: [
                {
                    borderColor: colors[0],
                    data: baseData[
                        tableDef.rows.find((r) => r.name == "REAL_RECEIPTS").index
                    ].slice(1),
                    fill: false,
                    label: "Recettes réelles",
                },
                {
                    borderColor: colors[1],
                    data: baseData[
                        tableDef.rows.find((r) => r.name == "REAL_EXPENSES").index
                    ].slice(1),
                    fill: false,
                    label: "Dépenses réelles",
                },
                {
                    borderColor: colors[2],
                    data: baseData[
                        tableDef.rows.find((r) => r.name == "CAFB").index
                    ].slice(1),
                    fill: false,
                    label: "CAF brute",
                },
                {
                    borderColor: colors[3],
                    data: baseData[
                        tableDef.rows.find((r) => r.name == "LOANS").index
                    ].slice(1),
                    fill: false,
                    label: "Remboursement capital emprunts",
                },
                {
                    borderColor: colors[4],
                    data: baseData[
                        tableDef.rows.find((r) => r.name == "CAFN").index
                    ].slice(1),
                    fill: false,
                    label: "CAF nette",
                },
            ],
        };
    }

    private buildChartDataRevenuesSpending(
        tableDef: ReturnType<typeof TableDefinition>,
        baseData: Data,
        receipts: boolean
    ): Chart.ChartData {
        const data: Chart.ChartData = { labels: [], datasets: [] };
        const chapters = tableDef.rows.filter(
            (row) => row.scenario && row.chapter && row.chapter.receipts === receipts
        );
        const colors = ColorsHelper.getEquidistantPastelColors(chapters.length, 30);
        const dataset: Chart.ChartDataSets = { backgroundColor: colors, data: [] };

        baseData.forEach((row) => {
            let chapter = chapters.find((ch) => ch.title === row[0]);
            if (!chapter || !row[7]) return;

            (dataset.data as number[]).push(row[7]);
            data.labels.push(chapter.title);
        });

        data.datasets.push(dataset);

        return data;
    }

    private buildChartDataBar(
        tableDef: ReturnType<typeof TableDefinition>,
        baseData: Data,
        receipts: boolean
    ): Chart.ChartData {
        const years = this.state.years.slice(1, this.state.years.length - 5);
        const data: Chart.ChartData = { labels: years, datasets: [] };
        const chapters = tableDef.rows.filter(
            (row) => row.scenario && row.chapter && row.chapter.receipts === receipts
        );
        const colors = ColorsHelper.getEquidistantPastelColors(chapters.length, 30);
        let iColor = 0;

        baseData.forEach((row) => {
            const dataset = {
                backgroundColor: colors[iColor],
                data: [],
                label: null,
            };
            const chapter = chapters.find((ch) => ch.title === row[0]);
            if (!chapter) return;
            const label = chapter.title;
            let sum = 0;
            this.state.years.forEach((year, index) => {
                if (index < 2 || index > 7) return;
                if (row[index]) {
                    dataset.data.push(row[index]);
                    sum += row[index];
                } else {
                    dataset.data.push(0);
                    sum += 0;
                }
            });
            dataset.label = label;
            if (sum != 0) {
                data.datasets.push(dataset);
                iColor += 1;
            }
        });

        return data;
    }

    private createYears(props: Readonly<any>): number[] {
        const reference = props.scenario ? props.scenario.year : this.currentYear;
        const end = reference + 6;
        const start = end - 12;
        const years: number[] = [];

        for (let year = start; year < end; year++) years.push(year);

        return years;
    }

    private getTableDefinition(): ReturnType<typeof TableDefinition> {
        return this.tableDefs[this.state.currentTab](
            this.props.scenario,
            this.state.currentTab,
            this.props.currentLocalAuthority,
            this.state.shownChapters[this.state.currentTab],
            this.state.priorities
        );
    }

    private getTableDefinitionExcel(
        res: string
    ): ReturnType<typeof TableDefinition> {
        return this.tableDefs[res](
            this.props.scenario,
            res,
            this.props.currentLocalAuthority,
            this.state.shownChapters[res],
            this.state.priorities
        );
    }

    private getTableDefinitionExcelTable(
        res: string,
        shownChapters
    ): ReturnType<typeof TableDefinition> {
        return this.tableDefs[res](
            this.props.scenario,
            res,
            this.props.currentLocalAuthority,
            shownChapters[res],
            this.state.priorities
        );
    }

    private getOperations(): Operations {
        const key = `${this.props.scenario.id}-${this.props.scenario.years ? this.props.scenario.years.length : 0}`;
        if (this._cachedOperations && this._cachedOperationsKey === key) {
            return this._cachedOperations;
        }
        this._cachedOperations = new Operations(
            this.props.scenario,
            this.props.ppi,
            this.props.currentLocalAuthority
        );
        this._cachedOperationsKey = key;
        return this._cachedOperations;
    }

    private getInterestByYear(year: number): number {
        if (!this._interestByYearCache) {
            this._interestByYearCache = new Map();
            for (const y of this.state.years) {
                this._interestByYearCache.set(y, LoanDomain.getTotalInterestByYear(this.props.loans, y));
            }
        }
        return this._interestByYearCache.get(year) || 0;
    }

    private getObsMap(): Map<string, any> {
        if (!this._obsMap) {
            this._obsMap = new Map();
            if (this.props.currentLocalAuthority.observations) {
                for (const o of this.props.currentLocalAuthority.observations) {
                    const key = `${o.year}-${o.account.id}`;
                    if (!this._obsMap.has(key)) {
                        this._obsMap.set(key, o);
                    }
                }
            }
        }
        return this._obsMap;
    }

    private invalidateCaches(): void {
        this._cachedOperations = null;
        this._cachedOperationsKey = null;
        this._cachedLoans = null;
        this._cachedLoansKey = null;
        this._interestByYearCache = null;
        this._obsMap = null;
    }

    private handleAccountChange(data: Common.AccountChangeData): void {
        const scenario = this.props.scenario;

        if (data.isCommentEdited) {
            if (data.comment == null) {
                var index = scenario.accounts
                    .map((a) => a.account_id + "-" + a.receipts)
                    .indexOf(data.account.id + "-" + (this.state.currentTab == "revenues"));
                scenario.accounts.splice(index, 1);

                ScenariiService.deleteAccountComment(
                    this.props.scenario,
                    data.account,
                    this.state.currentTab == "revenues"
                )
                    .then((s) => this.handleScenarioUpdate(s))
                    .catch((r) => this.handleFetchError(r));
            } else {
                var account = scenario.accounts.find(
                    (c) =>
                        c.account_id == data.account.id &&
                        c.receipts == (this.state.currentTab == "revenues")
                );

                if (!account) {
                    account = {
                        account_id: data.account.id,
                        chapter_id: data.chapter.id,
                        amount: data.amount,
                        comment: data.comment,
                        receipts: this.state.currentTab == "revenues",
                    } as Model.ScenarioAccount;
                    scenario.accounts.push(account);
                } else {
                    account.amount = data.amount;
                }

                for (const y of scenario.years) {
                    y.accounts = y.accounts.filter((a) => a.account_id !== data.account.id);
                }

                ScenariiService.updateAccountComment(
                    this.props.scenario,
                    data.account,
                    data.comment,
                    this.state.currentTab == "revenues"
                )
                    .then((s) => this.handleScenarioUpdate(s))
                    .catch((r) => this.handleFetchError(r));
            }
        }
        else {
            if (data.amount == null) {
                var index = scenario.accounts
                    .map((a) => a.account_id + "-" + a.receipts)
                    .indexOf(data.account.id + "-" + (this.state.currentTab == "revenues"));
                scenario.accounts.splice(index, 1);

                ScenariiService.deleteAccountValue(
                    this.props.scenario,
                    data.account,
                    this.state.currentTab == "revenues"
                )
                    .then((s) => this.handleScenarioUpdate(s))
                    .catch((r) => this.handleFetchError(r));
            } else {
                var account = scenario.accounts.find(
                    (c) =>
                        c.account_id == data.account.id &&
                        c.receipts == (this.state.currentTab == "revenues")
                );

                if (!account) {
                    account = {
                        account_id: data.account.id,
                        chapter_id: data.chapter.id,
                        amount: data.amount,
                        comment: data.comment,
                        receipts: this.state.currentTab == "revenues",
                    } as Model.ScenarioAccount;
                    scenario.accounts.push(account);
                } else {
                    account.amount = data.amount;
                }

                for (const y of scenario.years) {
                    y.accounts = y.accounts.filter((a) => a.account_id !== data.account.id);
                }

                ScenariiService.updateAccountValue(
                    this.props.scenario,
                    data.account,
                    data.amount,
                    this.state.currentTab == "revenues"
                )
                    .then((s) => this.handleScenarioUpdate(s))
                    .catch((r) => this.handleFetchError(r));
            }
        }
    }

    private handleCommentChange(data: any): void {
        this.handleScenarioUpdate(data);
    }

    private handleAccountYearChange(data): void {
        const scenario = this.props.scenario;
        let scenarioYear = scenario.years.find((y) => y.year == data.year);

        if (!scenarioYear) {
            scenarioYear = { accounts: [], year: data.year } as Model.ScenarioYear;
        } else if (!scenarioYear.accounts) {
            scenarioYear.accounts = [];
        }

        if (data.amount == null) {
            var index = scenarioYear.accounts
                .map((a) => a.account_id + "-" + a.receipts)
                .indexOf(data.account.id + "-" + (this.state.currentTab == "revenues"));
            scenarioYear.accounts.splice(index, 1);
            ScenariiService.deleteValue(
                this.props.scenario,
                data.year,
                data.account,
                this.state.currentTab == "revenues"
            )
                .then((s) => this.handleScenarioUpdate1(s, data.postion))
                .catch((reason) => this.handleFetchError(reason));
        } else {
            var scenarioYearAccount = scenarioYear.accounts.find(
                (a) =>
                    a.account_id == data.account.id &&
                    a.receipts == (this.state.currentTab == "revenues")
            );
            if (!scenarioYearAccount) {
                scenarioYearAccount = {
                    account_id: data.account.id,
                    chapter_id: data.chapter.id,
                    amount: data.amount,
                    percentile: data.percentile,
                    receipts: this.state.currentTab == "revenues",
                } as Model.ScenarioYearAccount;
                scenarioYear.accounts.push(scenarioYearAccount);
            } else {
                scenarioYearAccount.amount = data.amount;
                scenarioYearAccount.percentile = data.percentile;
            }
            ScenariiService.updateValue(
                this.props.scenario,
                data.year,
                data.account,
                data.amount,
                data.percentile,
                this.state.currentTab == "revenues"
            )
                .then((s) => this.handleScenarioUpdate1(s, data.postion))
                .catch((reason) => this.handleFetchError(reason));
        }
    }

    private handleScenarioUpdate1(scenario: Model.Scenario, postion: any): void {
        this.invalidateCaches();
        this.props.onScenarioUpdated1(scenario, postion);
        this.setState({ edit: false, submitting: false });
    }

    private handleChapterChange(data: Common.ChapterChangeData): void {
        const scenario = this.props.scenario;

        if (data.amount == null) {
            const index = scenario.chapters
                .map((c) => c.chapter_id + "-" + c.receipts)
                .indexOf(data.chapter.id + "-" + (this.state.currentTab == "revenues"));

            scenario.chapters.splice(index, 1);

            ScenariiService.deleteChapterValue(
                this.props.scenario,
                data.chapter,
                this.state.currentTab == "revenues"
            )
                .then((s) => this.handleScenarioUpdate(s))
                .catch((r) => this.handleFetchError(r));
        } else {
            let chapter = scenario.chapters.find(
                (c) =>
                    c.chapter_id == data.chapter.id &&
                    c.receipts == (this.state.currentTab == "revenues")
            );

            if (!chapter) {
                chapter = {
                    chapter_id: data.chapter.id,
                    amount: data.amount,
                    receipts: this.state.currentTab == "revenues",
                } as Model.ScenarioChapter;
                scenario.chapters.push(chapter);
            } else {
                chapter.amount = data.amount;
            }

            scenario.accounts = scenario.accounts.filter(
                (a) => a.chapter_id !== data.chapter.id
            );

            for (const y of scenario.years) {
                y.accounts = y.accounts.filter((a) => a.chapter_id !== data.chapter.id);
            }

            ScenariiService.updateChapterValue(
                this.props.scenario,
                data.chapter,
                data.amount,
                this.state.currentTab == "revenues"
            )
                .then((s) => this.handleScenarioUpdate(s))
                .catch((r) => this.handleFetchError(r));
        }
    }

    private handleToggleChapter(chapter: DicoChapter): void {
        this.setState({ loading: true }, () => {
            const { id } = chapter;
            let shownChapters = this.state.shownChapters;
            const index = shownChapters[this.state.currentTab].indexOf(id);

            if (index !== -1) {
                shownChapters[this.state.currentTab].splice(index, 1);
            } else {
                shownChapters[this.state.currentTab].push(id);
            }

            this.consulted =
                UserDomain.getProfile(this.props.currentUser) ===
                UserDomain.Profile.LocalAuthorityConsultant;
            this.tableDef = this.getTableDefinition();
            this.data = this.buildData(this.tableDef, "");

            this.setState({ shownChapters, loading: false });
        });
    }

    private handleChange(type: Common.ChangeType, data: Common.ChangeData): void {
        switch (type) {
            case "account_year":
                this.handleAccountYearChange(data);
                break;
            case "account":
                this.handleAccountChange(data as Common.AccountChangeData);
                break;
            case "chapter":
                this.handleChapterChange(data as Common.ChapterChangeData);
                break;
            case "main":
                this.handleMainChange(data as Common.Changes);
                break;
            case "account_comment":
                this.handleCommentChange(data as Common.AccountYearChangeData);
                break;
        }
    }

    private handleMainChange(data: Common.Changes): void {
        if (isSynthesis(this.state.currentTab) && data) {
            const col = data[0][1];
            let value = data[0][3];

            if (value == "") value = null;

            const scenario = this.props.scenario;

            if (col > 6) {
                var year = scenario.years.find(
                    (y) => y.year == this.props.scenario.year + col - 7
                );
                if (!year) {
                    year = {
                        year: this.props.scenario.year + col - 7,
                        accounts: [],
                    } as Model.ScenarioYear;
                    scenario.years.push(year);
                }

                year.previous = value;
                this.state.years
                    .slice(6)
                    .map((year) => {
                        if (year == this.props.scenario.year) {
                            ScenariiService.updatePreviousResult(
                                this.props.scenario,
                                year,
                                value
                            )
                                .then((s) => this.handleScenarioUpdate(s, year, value))
                                .catch((r) => this.handleFetchError(r))
                        }
                    }
                    )
            } else {
                scenario.previousResult = value;
                ScenariiService.updateScenario(this.props.scenario.id, {
                    previousResult: value,
                })
                    .then((s) => this.handleScenarioUpdate(s))
                    .catch((r) => this.handleFetchError(r));
            }
        }
    }

    private handleFetchError(error: any): void {
        this.setState({ error, submitting: false, edit: false });
        this.dispatchReceiveError(error);
    }

    private handlePrioritiesChange(priorities: number[]): void {
        this.setState({ priorities });
    }

    private handleScenarioUpdate(scenario: Model.Scenario, year?, value?): void {
        this.invalidateCaches();
        this.props.onScenarioUpdated(scenario, year, value);
        this.setState({ edit: false, submitting: false });
    }

    private dispatchReceiveError(error: any): void {
        this.props.actions.throwError(error);
        this.setState({ loading: false });
    }

    private buildLoans(): Model.PpiYearLoan[] {
        const lds = LoanDomain.getLoansWithDecomposition(this.props.loans),
            years = this.state.years;

        let yearLoans: Model.PpiYearLoan[] = [],
            yearLoan: Model.PpiYearLoan;

        lds.forEach((ld) => {
            const decomposition = ld.decomposition;
            const loan = ld.loan;
            let decom = {
                interests: [],
                paymentAmounts: [],
                paymentDates: [],
                periodicRates: [],
                reimboursedCapitals: [],
                remainingCapitals: [],
            };
            decomposition.paymentDates.map((date, i) => {
                if (decomposition.remainingCapitals[i] > 0) {
                    decom.interests.push(decomposition.interests[i]);
                    decom.paymentAmounts.push(decomposition.paymentAmounts[i]);
                    decom.paymentDates.push(date);
                    decom.periodicRates.push(decomposition.periodicRates[i]);
                    decom.reimboursedCapitals.push(decomposition.reimboursedCapitals[i]);
                    decom.remainingCapitals.push(decomposition.remainingCapitals[i]);
                }
            });
            years.forEach((year) => {
                yearLoan = yearLoans.find((yl) => yl.year == year);
                if (!yearLoan) {
                    yearLoan = {
                        year: year,
                        total: 0,
                        reimbourse: 0,
                        interests: 0,
                        remaining: 0,
                        reimbours: 0,
                    };
                    yearLoans.push(yearLoan);
                }
                if (parseInt(moment(ld.loan.contractedOn).format("YYYY")) == year) {
                    yearLoan.total += ld.loan.amount; //getAnnuity(ld.decomposition, year)
                }

                if (isNaN(yearLoan.reimbourse)) yearLoan.reimbourse = 0;
                yearLoan.reimbourse += LoanDomain.getYearReimboursedCapital(
                    decomposition,
                    year
                );
                if (isNaN(yearLoan.interests)) yearLoan.interests = 0;
                yearLoan.interests += LoanDomain.getYearInterest(decomposition, year);
                if (isNaN(yearLoan.remaining)) yearLoan.remaining = 0;
                yearLoan.remaining += LoanDomain.getYearRemainingCapital(
                    decomposition,
                    year
                );

                /* Shifted year calculation Remborsement emprunts row */
                if (isNaN(yearLoan.reimbours)) yearLoan.reimbours = 0;
                yearLoan.reimbours += LoanDomain.getYearReimboursedCapital(decom, year);
            });
        });

        // En dette simplifiée, le remboursement du capital ne vient pas de la
        // dette détaillée mais de l'écran de dette simplifiée (emprunts réels +
        // emprunts simulés), comme dans le PPI et le rapport de gestion.
        const simulatedTotals = LoanDomain.getSimulatedLoansTotalsByYear(
            this.props.loans || [],
            years
        );

        years.forEach((year) => {
            const reimbursedCapital = LoanDomain.getSimplifiedDebtReimbursedCapital(
                this.props.currentLocalAuthority,
                this.props.ppi,
                yearLoans,
                simulatedTotals,
                year
            );
            if (reimbursedCapital == null) return;

            let simplifiedYearLoan = yearLoans.find((yl) => yl.year == year);
            if (!simplifiedYearLoan) {
                // Collectivité sans emprunt dans la dette détaillée : l'année
                // n'a pas encore d'entrée.
                simplifiedYearLoan = {
                    year: year,
                    total: 0,
                    reimbourse: 0,
                    interests: 0,
                    remaining: 0,
                    reimbours: 0,
                };
                yearLoans.push(simplifiedYearLoan);
            }
            simplifiedYearLoan.reimbourse = reimbursedCapital;
            simplifiedYearLoan.reimbours = reimbursedCapital;
        });

        return yearLoans;
    }
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state;
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>) {
    return { actions: bindActionCreators(actionCreators, dispatch) };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ScenarioDetailContainer);

export interface Props {
    loans: Model.Loan[];
    ppi: Model.Ppi;
    scenarii: Scenarii[];
    scenario: Model.Scenario;
    onScenarioUpdated1: void;

    onBack(): void;

    onScenarioUpdated(scenario: Model.Scenario): void;
}

export type Value = number | Common.Value;

interface Scenarii {
    scenarii: Model.Scenario[];
    year: number;
}

interface ShownChapters {
    revenues: number[];
    spending: number[];
}

interface State {
    currentTab: TabId;
    edit: boolean;
    error?: any;
    graphic: boolean;
    loading: boolean;
    priorities: number[];
    shownChapters: ShownChapters;
    submitting: boolean;
    years: number[];
    revenues: any;
    spending: any;
    synthesis: any;
    revenuesTableDef: any;
    spendingTableDef: any;
    synthesisTableDef: any;
    isRendered?: boolean;
    hideRows: boolean;
}

type InjectedProps = Props & ReducerState & MappedActionsProps;



// WEBPACK FOOTER //
// ./src/component/scenarii/detail/detail-container.tsx